import React, { FC, ReactElement } from 'react';
import { Theme } from '@mui/material/styles';
import makeStyles from '@mui/styles/makeStyles';
import createStyles from '@mui/styles/createStyles';
import Avatar, { AvatarProps } from '@mui/material/Avatar';

import { clsx } from 'clsx';

interface AvatarTextProps extends AvatarProps {
    title: string;
}

const AvatarText: FC<AvatarTextProps> = (props): ReactElement => {
    const classes = useStyles();

    const { title, className } = props;

    if (!title) {
        return null;
    }

    return (
        <Avatar className={clsx(classes.avatar, className)} sizes="small" variant="rounded">
            {title}
        </Avatar>
    );
};

const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        avatar: {
            margin: 0,
            height: 22,
            width: 'auto',
            fontSize: 12,
            fontWeight: 500,
            borderRadius: 12,
            padding: '4px 12px',
            backgroundColor: theme.palette.colors.background.focusElement,
        },
    }),
);

export default AvatarText;
